module.exports = __webpack_public_path__ + "img/ic-60-ahorro.17c7feac.svg";